import React from 'react';
import { Dialog, makeStyles } from '@material-ui/core';
import { configureEnvironment } from '../../../config/env';
import Botao from '../../../shared/components/Botao';

const ModalImpressaoApplet = props => {
    const classes = useStyles(props);
    const {
        modalAberto,
        fecharModal,
        codigoLaboratorio,
        idLote
    } = props;

    const impressaoApplet = (modalAberto ? (
        <span id="objPrintIe">
            <object classID="clsid:8AD9C840-044E-11D1-B3E9-00805F499D93">
                <param name="code" value="Print.class" />
                <param name="archive" value={configureEnvironment().REACT_APP_URL_JAR_IMPRESSAO} />
                <param name="type" value="application/x-java-applet;version=1.6" />
                <param name="URL" value={`${configureEnvironment().REACT_APP_API_URL}/lotes/${codigoLaboratorio}/${idLote}/etiqueta`} />
            </object>
            <Botao titulo="Fechar" onClick={fecharModal} type='primary' />
        </span>
    ) : <p>Carregando...</p>
    );

    return (
        <Dialog
            fullWidth
            classes={{ paperWidthXs: classes.paperWidthXs }}
            maxWidth={'xs'}
            open={modalAberto}
            onClose={fecharModal}
        >
            {impressaoApplet}
        </Dialog>
    );
}

const useStyles = makeStyles({
    paperWidthXs: {
        width: '350px'
    }
});

export default ModalImpressaoApplet;